import React, { FC, useEffect, useRef, useState } from 'react';
import { preworkDataStore } from 'src/store/preworkInfo';
import { dateCalendarFormatType } from 'src/utils/dateSet';
import { getMemberInfo } from 'src/utils/common';
import InputBox from 'src/components/atoms/input/DefInputBox';
import InputDateBox from 'src/components/atoms/input/InputDateBox';
import { checkRequired } from 'src/store/preworkInfo';
import { getBizNo, formatBizNo } from 'src/utils/charSet';
import './style.scss';

interface Props {
  data: any;
  type: string;
}
const GridList: FC<Props> = ({ data, type }) => {
  const preworkPayload = preworkDataStore((state: any) => state.payload);
  const bindPreworkPayload = preworkDataStore((state: any) => state.bindPayload);

  // 귀속연도(acct_year) 범위로만 근무/감면 기간 선택 가능
  const memberInfo: any = getMemberInfo() || {};
  const acctYear = parseInt(memberInfo.acct_year, 10) || new Date().getFullYear();
  const acctYearMinDate = `${acctYear}0101`;
  const acctYearMaxDate = `${acctYear}1231`;

  const foldClickEvent = (id: string, status: string) => {};
  const ocrEvt = () => {};
  const labelStyle = { width: '180px', color: '#777', fontSize: '13px' };
  const calendarStartRef = useRef<HTMLInputElement | null>(null);
  const calendarEndRef = useRef<HTMLInputElement | null>(null);
  const calendarRedStartRef = useRef<HTMLInputElement | null>(null);
  const calendarRedEndRef = useRef<HTMLInputElement | null>(null);

  const calendarStartEvt = (value: string) => {
    const date = value || '';
    const dateSet = date.replaceAll('.', '');
    bindPreworkPayload({ ...preworkPayload, start_date: dateSet });
  };
  const calendarEndEvt = (value: string) => {
    const date = value || '';
    const dateSet = date.replaceAll('.', '');
    bindPreworkPayload({ ...preworkPayload, end_date: dateSet });
  };
  const calendarRedStartEvt = (value: string) => {
    const date = value || '';
    const dateSet = date.replaceAll('.', '');
    bindPreworkPayload({ ...preworkPayload, red_start_date: dateSet });
  };
  const calendarRedEndEvt = (value: string) => {
    const date = value || '';
    const dateSet = date.replaceAll('.', '');
    bindPreworkPayload({ ...preworkPayload, red_end_date: dateSet });
  };
  const calendarEvt = (key: string, ref: any) => {
    const date = ref.current?.value || '';
    const dateSet = date.replaceAll('.', '');
    bindPreworkPayload({ ...preworkPayload, [key]: dateSet });
  };

  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    bindPreworkPayload({ ...preworkPayload, [key]: e.target.value });
  };

  const inpBizNoChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const resNum = formatBizNo(e.target.value);
    if (!resNum && resNum !== '') return false;
    bindPreworkPayload({ ...preworkPayload, [key]: resNum });
  };

  return (
    <div className="_company_detail_input_set">
      <div className="_content_div">
        <div className="_detail_content_div _active">
          <div className="_row">
            <div className="_item _half" style={{ zIndex: 20 }}>
              <InputBox
                changeEvt={e => inpChangeEvt(e, 'prev_co_name')}
                label="회사명"
                labelPosition="left"
                required={type !== 'list' ? checkRequired('prev_co_name') : ''}
                value={preworkPayload.prev_co_name || ''}
                placeholder="회사명을 입력하세요"
                labelStyleDef={labelStyle}
                styleDef={{ fontSize: '15px', fontWeight: '700' }}
                status={type === 'list' ? '_read' : ''}
                inpStyleDef={{ textAlign: 'right' }}
              />
            </div>
            <div className="_item_r _half" style={{ zIndex: 20 }}>
              <InputBox
                changeEvt={e => inpBizNoChangeEvt(e, 'prev_co_num')}
                label="사업자번호( - 제외)"
                labelPosition="left"
                required={type !== 'list' ? checkRequired('prev_co_num') : ''}
                value={
                  type !== 'add'
                    ? getBizNo(preworkPayload.prev_co_num || '')
                    : preworkPayload.prev_co_num || ''
                }
                placeholder="사업자번호를 입력하세요"
                labelStyleDef={labelStyle}
                styleDef={{ fontSize: '15px', fontWeight: '700' }}
                status={type !== 'add' ? '_read' : ''}
                inpStyleDef={{ textAlign: 'right' }}
              />
            </div>
          </div>

          <div className="_row">
            <div className="_item _half" style={{ zIndex: 30 }}>
              {type === 'list' ? (
                <InputBox
                  changeEvt={e => inpChangeEvt(e, 'start_date')}
                  label="근무기간 시작"
                  labelPosition="left"
                  value={dateCalendarFormatType(preworkPayload.start_date) || '-'}
                  placeholder=""
                  labelStyleDef={labelStyle}
                  styleDef={{ fontSize: '14px' }}
                  status={'_read'}
                  inpStyleDef={{ textAlign: 'right' }}
                />
              ) : (
                <InputDateBox
                  inpRef={calendarStartRef}
                  value={dateCalendarFormatType(preworkPayload.start_date || '')}
                  required={type !== 'list' ? checkRequired('start_date') : ''}
                  status={type === 'list' ? '_read' : ''}
                  direction="right"
                  placeholder=""
                  label="근무기간 시작"
                  labelPosition="left"
                  labelStyleDef={labelStyle}
                  styleDef={{ width: 'calc(100% - 180px)' }}
                  clickCalendarEvt={calendarStartEvt}
                  minDate={acctYearMinDate}
                  maxDate={acctYearMaxDate}
                />
              )}
            </div>
            <div className="_item_r _half" style={{ zIndex: 30 }}>
              {type === 'list' ? (
                <InputBox
                  changeEvt={e => inpChangeEvt(e, 'end_date')}
                  label="근무기간 종료"
                  labelPosition="left"
                  value={dateCalendarFormatType(preworkPayload.end_date) || '-'}
                  placeholder=""
                  labelStyleDef={labelStyle}
                  styleDef={{ fontSize: '14px' }}
                  status={'_read'}
                  inpStyleDef={{ textAlign: 'right' }}
                />
              ) : (
                <InputDateBox
                  inpRef={calendarEndRef}
                  value={dateCalendarFormatType(preworkPayload.end_date || '')}
                  required={type !== 'list' ? checkRequired('end_date') : ''}
                  status={type === 'list' ? '_read' : ''}
                  direction="right"
                  placeholder=""
                  label="근무기간 종료"
                  labelPosition="left"
                  labelStyleDef={labelStyle}
                  styleDef={{ width: 'calc(100% - 180px)' }}
                  clickCalendarEvt={calendarEndEvt}
                  minDate={acctYearMinDate}
                  maxDate={acctYearMaxDate}
                  // labelStyleDef={{ fontSize: '13px', width: '80px' }}
                />
              )}
            </div>
          </div>
          <div className="_row">
            <div className="_item _half" style={{ zIndex: 20 }}>
              {type === 'list' ? (
                <InputBox
                  changeEvt={e => inpChangeEvt(e, 'end_date')}
                  label="감면기간 시작"
                  labelPosition="left"
                  value={dateCalendarFormatType(preworkPayload.red_start_date) || '-'}
                  placeholder=""
                  labelStyleDef={labelStyle}
                  styleDef={{ fontSize: '14px' }}
                  status={'_read'}
                  inpStyleDef={{ textAlign: 'right' }}
                />
              ) : (
                <InputDateBox
                  inpRef={calendarRedStartRef}
                  value={dateCalendarFormatType(preworkPayload.red_start_date || '')}
                  required={type !== 'list' ? checkRequired('red_start_date') : ''}
                  status={type === 'list' ? '_read' : ''}
                  direction="left"
                  placeholder=""
                  label="감면기간 시작"
                  labelPosition="left"
                  labelStyleDef={labelStyle}
                  styleDef={{ width: 'calc(100% - 180px)' }}
                  clickCalendarEvt={calendarRedStartEvt}
                  defaultToday={false}
                  minDate={acctYearMinDate}
                  maxDate={acctYearMaxDate}
                />
              )}
            </div>
            <div className="_item_r _half" style={{ zIndex: 20 }}>
              {type === 'list' ? (
                <InputBox
                  changeEvt={e => inpChangeEvt(e, 'red_end_date')}
                  label="감면기간 종료"
                  labelPosition="left"
                  value={dateCalendarFormatType(preworkPayload.red_end_date) || '-'}
                  placeholder=""
                  labelStyleDef={labelStyle}
                  styleDef={{ fontSize: '14px' }}
                  status={'_read'}
                  inpStyleDef={{ textAlign: 'right' }}
                />
              ) : (
                <InputDateBox
                  inpRef={calendarRedEndRef}
                  value={dateCalendarFormatType(preworkPayload.red_end_date || '')}
                  required={type !== 'list' ? checkRequired('red_end_date') : ''}
                  status={type === 'list' ? '_read' : ''}
                  direction="right"
                  placeholder=""
                  label="감면기간 종료"
                  labelPosition="left"
                  labelStyleDef={labelStyle}
                  styleDef={{ width: 'calc(100% - 180px)' }}
                  clickCalendarEvt={calendarRedEndEvt}
                  defaultToday={false}
                  minDate={acctYearMinDate}
                  maxDate={acctYearMaxDate}
                  // labelStyleDef={{ fontSize: '13px', width: '80px' }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GridList;
